import { useContext } from 'react';

import { globalConfig } from './globalConfig';
import type { GlobalConfig } from './types';

export const useGlobalConfig = (): GlobalConfig => useContext(globalConfig);
